import "@dxos/node-std/globals";
import {
  __toESM,
  require_hypercore_crypto
} from "./chunk-DEF4I65T.mjs";

// src/hypercore-crypto.js
var import_hypercore_crypto = __toESM(require_hypercore_crypto(), 1);
var export_default = import_hypercore_crypto.default;
var export_discoveryKey = import_hypercore_crypto.discoveryKey;
var export_keyPair = import_hypercore_crypto.keyPair;
var export_randomBytes = import_hypercore_crypto.randomBytes;
var export_sign = import_hypercore_crypto.sign;
var export_validateKeyPair = import_hypercore_crypto.validateKeyPair;
var export_verify = import_hypercore_crypto.verify;
export {
  export_default as default,
  export_discoveryKey as discoveryKey,
  export_keyPair as keyPair,
  export_randomBytes as randomBytes,
  export_sign as sign,
  export_validateKeyPair as validateKeyPair,
  export_verify as verify
};
//# sourceMappingURL=hypercore-crypto.mjs.map
